import ApiConnection from "./connection";

const login = async (userData) =>
  ApiConnection.post("users/auth", userData)
    .then((response) => ({
      output: response.data,
      status: response.status,
      message: response.data?.message,
    }))
    .catch((e) => ({
      output: e.response?.data,
      status: e.response?.status,
      message: e.response?.data?.message,
    }));

const getPatient = async (userData, token) => {
  try {
    const response = await ApiConnection.post(
      "users/GetPatientByInfo",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return {
      output: response.data,
      status: response.status,
      message: response.data?.message,
    };
  } catch (e) {
    return {
      output: e.response?.data,
      status: e.response?.status,
      message: e.response?.data?.message,
    };
  }
};
const acceptTerms = async ({ username, name, crm }, token) => {
  try {
    const response = await ApiConnection.post(
      "users/accepted-terms",
      {
        username,
        name,
        crm,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return {
      output: response.data,
      status: response.status,
      message: response.message,
    };
  } catch (e) {
    return {
      status: e.response.status,
      message: e.response.data.message,
      data: e.response.data.data,
    };
  }
};
const registerOccurrence = async (userData, token) => {
  try {
    const response = await ApiConnection.post(
      "users/register-occurrence",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return {
      output: response.data,
      status: response.status,
      message: response.data?.message,
    };
  } catch (e) {
    return {
      output: e.response?.data,
      status: e.response?.status,
      message: e.response?.data?.message,
    };
  }
};

const getAllByPage = async (token) =>
  ApiConnection.get(`users`, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const getByID = async (token, id) =>
  ApiConnection.get(`users/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const create = async (token, userData) =>
  ApiConnection.post(`users`, userData, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const update = async (token, userData, userID) =>
  ApiConnection.put(`users/${userID}`, userData, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const ban = async (token, userID) =>
  ApiConnection.put(
    `users/${userID}/ban`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  )
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const active = async (token, userID) =>
  ApiConnection.put(
    `users/${userID}/active`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  )
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const insertDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/insert`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const updateDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/update`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const deleteDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/delete`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const getAllArquives = async (token) => {
  try {
    const response = await ApiConnection.get("files", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const getAllUnimedMama = async (token) => {
  try {
    const response = await ApiConnection.get("unimed-mama", {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getAllRedeSus = async (token, username) => {
  try {
    const response = await ApiConnection.get(
      `rede-sus/getAll/${username}`, //
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getHistoricTumorBoard = async (token, data) => {
  try {
    const response = await ApiConnection.post(`tumor-board/getHistoric`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const HideReport = async (token, Data) => {
  return ApiConnection.post(`tumor-board/hide-report`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const insertHistoric = async (token, Data) => {
  return ApiConnection.post(`tumor-board/insert-historic`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const registerTumorBoard = async (token, Data) => {
  return ApiConnection.post(`tumor-board/register`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const updateTumorBoard = async (token, Data) => {
  return ApiConnection.post(`tumor-board/update`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const getAllTumorBoard = async (token, username) => {
  try {
    const response = await ApiConnection.get(`tumor-board/getAll/${username}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getAllTumorBoardPatients = async (token, username, NomPaciente) => {
  try {
    const response = await ApiConnection.get(
      `tumor-board/getAllPac/${username}/${NomPaciente}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getDesfecho = async (token) => {
  try {
    const response = await ApiConnection.get("unimed-desfecho", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const GetTumorBoardReports = async (token, CodPaciente, username) => {
  try {
    const response = await ApiConnection.get(
      `tumor-board/getReports/${username}/${CodPaciente}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const getAllUnimedMamaByDate = async (token, username, dateStart, dateEnd) => {
  try {
    const response = await ApiConnection.get(
      `/unimed-mama-by-date/${dateStart}/${dateEnd}/${username}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};
const getAllConvenioGrupoByDate = async (token, username, code, dateStart, dateEnd) => {
  try {
    const response = await ApiConnection.get(
      `/convenio-grupo-by-date/${dateStart}/${dateEnd}/${username}/${code}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const getAllConvenioGrupo = async (token, code) => {
  try {
    const response = await ApiConnection.get(`convenio-grupo/${code}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getAllRedeSusByDate = async (token, username, dateStart, dateEnd) => {
  try {
    const response = await ApiConnection.get(
      `/rede-sus-by-date/${dateStart}/${dateEnd}/${username}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const sendPhoneVerification = async (tel, username) => {
  try {
    const response = await ApiConnection.post("users/send-sms-verification", {
      tel,
      username,
    });

    return {
      output: response.data,
      status: response.status,
      message: response.message,
    }; // Aqui você pode retornar alguma mensagem ou indicativo de sucesso
  } catch (error) {
    if (error.response.status === 429) {
      alert(
        "Você excedeu o número máximo de tentativas diárias. O envio de SMS é limitado a três tentativas por dia. Para suporte, entre em contato pelo número: +55 47 99115-3595.",
      );
    }
    throw new Error(
      error.response.data.message || "Erro ao enviar email de verificação",
    );
  }
};

const sendMailVerification = async (email, username) => {
  try {
    const response = await ApiConnection.post("users/send-mail-verification", {
      email,
      username,
    });
    return {
      output: response.data,
      status: response.status,
      message: response.message,
    }; // Aqui você pode retornar alguma mensagem ou indicativo de sucesso
  } catch (error) {
    throw new Error(
      error.response.data.message || "Erro ao enviar email de verificação",
    );
  }
};

const twoFactorVerify = async (
  verificationCodeMail,
  id,
  verificationType,
  username,
) => {
  try {
    // Faz a chamada para a API
    const response = await ApiConnection.post("users/two-factor-verification", {
      verificationCodeMail,
      id,
      verificationType,
      username,
    });

    return response; // Retorna a resposta inteira
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Erro ao verificar código de verificação",
    );
  }
};

export default function user() {
  return {
    getAllArquives,
    sendPhoneVerification,
    twoFactorVerify,
    sendMailVerification,
    insertDesfecho,
    updateDesfecho,
    getAllRedeSusByDate,
    deleteDesfecho,
    getAllRedeSus,
    getAllTumorBoard,
    getAllUnimedMama,
    getAllUnimedMamaByDate,
    getAllConvenioGrupo,
    getAllConvenioGrupoByDate,
    getDesfecho,
    HideReport,
    GetTumorBoardReports,
    login,
    getByID,
    getAllByPage,
    create,
    registerTumorBoard,
    ban,
    updateTumorBoard,
    active,
    insertHistoric,
    getHistoricTumorBoard,
    registerOccurrence,
    update,
    getAllTumorBoardPatients,
    acceptTerms,
    getPatient,
  };
}
